class ReviewModalController {
  constructor({
    root = document,
    triggerSelector,
    modalSelector,
    closeSelector,
    openClass = 'is-open',
    preventDefaultOnTrigger = true,
    lockBodyScroll = true,
    closeOnOverlay = true,
    closeOnEscape = true,
  }) {
    this.root = root;
    this.triggerSelector = triggerSelector;
    this.modalSelector = modalSelector;
    this.closeSelector = closeSelector;
    this.openClass = openClass;
    this.preventDefaultOnTrigger = preventDefaultOnTrigger;
    this.lockBodyScroll = lockBodyScroll;
    this.closeOnOverlay = closeOnOverlay;
    this.closeOnEscape = closeOnEscape;

    this.elements = null;
    this.boundHandleTriggerClick = null;
    this.boundHandleCloseClick = null;
    this.boundHandleOverlayClick = null;
    this.boundHandleEscapeKey = null;
  }

  init() {
    const trigger = this.root.querySelector(this.triggerSelector);
    const modal = this.root.querySelector(this.modalSelector);
    const closeBtn = this.root.querySelector(this.closeSelector);

    if (!trigger || !modal || !closeBtn) return false;

    this.elements = { trigger, modal, closeBtn };
    this.boundHandleTriggerClick = this.handleTriggerClick.bind(this);
    this.boundHandleCloseClick = this.close.bind(this);
    this.boundHandleOverlayClick = this.handleOverlayClick.bind(this);
    this.boundHandleEscapeKey = this.handleEscapeKey.bind(this);

    trigger.addEventListener('click', this.boundHandleTriggerClick);
    closeBtn.addEventListener('click', this.boundHandleCloseClick);
    modal.addEventListener('click', this.boundHandleOverlayClick);
    document.addEventListener('keydown', this.boundHandleEscapeKey);

    return true;
  }

  open() {
    if (!this.elements?.modal) return;

    this.elements.modal.classList.add(this.openClass);

    if (this.lockBodyScroll) {
      document.body.style.overflow = 'hidden';
    }
  }

  close() {
    if (!this.elements?.modal) return;

    this.elements.modal.classList.remove(this.openClass);

    if (this.lockBodyScroll) {
      document.body.style.overflow = '';
    }
  }

  destroy() {
    if (!this.elements) return;

    const { trigger, modal, closeBtn } = this.elements;
    trigger.removeEventListener('click', this.boundHandleTriggerClick);
    closeBtn.removeEventListener('click', this.boundHandleCloseClick);
    modal.removeEventListener('click', this.boundHandleOverlayClick);
    document.removeEventListener('keydown', this.boundHandleEscapeKey);

    this.close();

    this.elements = null;
    this.boundHandleTriggerClick = null;
    this.boundHandleCloseClick = null;
    this.boundHandleOverlayClick = null;
    this.boundHandleEscapeKey = null;
  }

  handleTriggerClick(event) {
    if (this.preventDefaultOnTrigger) {
      event.preventDefault();
    }

    this.open();
  }

  handleOverlayClick(event) {
    if (!this.closeOnOverlay || !this.elements?.modal) return;

    if (event.target === this.elements.modal) {
      this.close();
    }
  }

  handleEscapeKey(event) {
    if (!this.closeOnEscape) return;

    if (event.key === 'Escape') {
      this.close();
    }
  }
}

window.ReviewModalController = ReviewModalController;